import React, { useState, useEffect } from "react";
import "./HeroSlider.css";
import image1 from "../../assets/new-ansal-2.jpg"; // Construction site image
import image2 from "../../assets/new-ansal-1.jpg"; // Residential building image
import image3 from "../../assets/new-ansal-3.png"; // Entrance gate image

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);

  const slides = [
    {
      id: 1,
      image: image1,
      title: "ANSAL ESENCIA GURGAON",
      subtitle: "SECTOR 67, GOLF EXTENSION ROAD GURUGRAM",
      description:
        "Premium residential project in the heart of Gurgaon's prime location",
    },
    {
      id: 2,
      image: image2,
      title: "ANSAL ESENCIA GURGAON",
      subtitle: "PRESENTING 3BHK LUXURY FLOORS",
      description:
        "Experience luxury living with modern amenities and elegant design",
    },
    {
      id: 3,
      image: image3,
      title: "ANSAL ESENCIA GURGAON",
      subtitle: "PREMIUM BUILDER FLOORS",
      description:
        "Thoughtfully designed independent floors with world-class facilities",
    },
  ];

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlay) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [isAutoPlay, slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlay(false);

    // Resume auto-play after 10 seconds
    setTimeout(() => setIsAutoPlay(true), 10000);
  };

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 10000);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 10000);
  };

  return (
    <section
      className="hero-slider"
      id="home"
      aria-roledescription="carousel"
      aria-label="Ansal Esencia highlights"
    >
      <div className="slider-container">
        {/* Single H1 for the carousel */}
        <div className="slide-content global-overlay">
          <div className="container">
            <div className="content-wrapper">
              <h1 className="slide-title">{slides[currentSlide].title}</h1>
              <h2 className="slide-subtitle">
                {slides[currentSlide].subtitle}
              </h2>
              <p className="slide-description">
                {slides[currentSlide].description}
              </p>
            </div>
          </div>
        </div>

        {/* Slides as backgrounds only */}
        <div className="slides-wrapper">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              role="group"
              aria-roledescription="slide"
              aria-label={`Slide ${index + 1} of ${slides.length}`}
              aria-hidden={index !== currentSlide}
            >
              {index === currentSlide ? (
                <img
                  className="slide-bg"
                  src={slide.image}
                  alt=""
                  aria-hidden="true"
                  decoding="async"
                  loading="eager"
                  fetchpriority="high"
                />
              ) : (
                <img
                  className="slide-bg"
                  src={slide.image}
                  alt=""
                  aria-hidden="true"
                  decoding="async"
                  loading="lazy"
                />
              )}
              <div className="slide-overlay" />
            </div>
          ))}
        </div>
        {/* Dots Navigation */}
        <div className="slider-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Auto-play indicator */}
        <div className="autoplay-indicator">
          <div
            className={`autoplay-progress ${isAutoPlay ? "playing" : "paused"}`}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
